var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.type.description }),expression:"{ content: type.description }"}],staticClass:"type"},[_vm._v(" "+_vm._s(_vm.type.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }